<template>
  <component
    :is="tagCompute"
    :to="to"
    :href="link"
    :target="target"
    :type="nativeButtonType"
    :aria-label="ariaLabel || undefined"
    class="breadcrumb-container inline-block mt-16"
    @click="clickEmitter"
  >
    <div v-if="header || ariaLabel" class="flex flex-row items-center breadcrumb" :aria-hidden="ariaLabel ? 'true' : undefined">
      <back-small-icon class="mr-4" />
      <span>{{ text }}</span>
    </div>
  </component>
</template>

<script lang="ts">
import BackSmallIcon from '../../graphics/icons/BackSmallIcon.vue';

export default {
  name: 'Breadcrumb',
  components: { BackSmallIcon },
  props: {
    header: {
      default: '',
      type: String,
    },
    to: {
      default: '',
      type: [String, Object],
    },
    href: {
      default: '',
      type: String,
    },
    target: {
      default: '',
      type: String,
    },
    anchorLink: {
      default: false,
      type: Boolean,
    },
    isButton: {
      default: false,
      type: Boolean,
    },
    ignoreQueryReturnPath: {
      default: false,
      type: Boolean,
    },
    ariaLabel: {
      default: '',
      type: String,
    },
  },
  computed: {
    queryReturnPath(): string | undefined {
      const q = (this.$route as { query?: { returnPath?: string; return_path?: string } } | undefined)?.query;
      return (q?.return_path ?? q?.returnPath) as string | undefined;
    },
    effectiveReturnPath(): string | undefined {
      if (this.ignoreQueryReturnPath) return undefined;
      return this.queryReturnPath;
    },
    tagCompute() {
      if (this.effectiveReturnPath) return 'a';
      if (this.to) return 'router-link';
      if (this.anchorLink) return 'a';
      if (this.isButton) return 'button';
      return 'div';
    },
    nativeButtonType(): 'button' | undefined {
      if (!this.isButton) return undefined;
      if (this.effectiveReturnPath || this.to || this.anchorLink) return undefined;
      return 'button';
    },
    link() {
      if (this.effectiveReturnPath) {
        return this.effectiveReturnPath;
      }
      return this.href || null;
    },
    text() {
      if (this.effectiveReturnPath) {
        return 'Back';
      }
      return this.header;
    },
  },
  methods: {
    clickEmitter(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb-container {
  position: relative;
  outline: none;
  cursor: pointer;
  &:focus-visible {
    // simulates hover effect with keyboard focus
    .breadcrumb,
    .breadcrumb svg path {
      color: theme('colors.brand.contrast');
      fill: theme('colors.brand.contrast');
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border: 2px dotted theme('colors.brand.contrast');
      margin: -4px;
      border-radius: theme('borderRadius.lg');
    }
  }
}

.breadcrumb {
  color: theme('colors.primary.DEFAULT');
  &:hover,
  &:hover svg path {
    color: theme('colors.brand.contrast');
    fill: theme('colors.brand.contrast');
  }
}
</style>
